import { useEffect } from "react";

const SITE_NAME = "SOREMO";

/**
 * ページ滞在中だけ document.title を差し替える。
 * アンマウント時は元のタイトルに戻す（SPA 内遷移で他ページのタイトルが残らないように）。
 *
 * @param title ページ固有のタイトル。`"| SOREMO"` は自動で付く。空文字ならサイト名のみ。
 */
const useDocumentTitle = (title: string): void => {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    return () => {
      document.title = previous;
    };
  }, [title]);
};

export default useDocumentTitle;
